import logo from './logo.svg';
import './App.css';
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ThemeProvider } from '@primer/react'
import theme from './theme'
import SignIn from './components/Authenticaton/SignIn'
import SignUp from './components/Authenticaton/SignUp'
import EmailVerification from './components/Authenticaton/EmailVerification';
import CreateWorkplace from './components/Workplace/CreateWorkplace';
import ForgetPassword from './components/Authenticaton/ForgetPassword';
import ResetPassword from './components/Authenticaton/ResetPassword';
import { Auth } from 'aws-amplify';
import React from 'react';
import Files from './components/Space/Files';
import Calander from './components/Space/Calander';
import Insight from './components/Space/Insight';
import Team from './components/Space/Team';
import Settings from './components/Space/Settings';
import Rules from "./components/Space/Rules"
import Apps from './components/Space/Apps'
import Template from './components/Workplace/Template';
import Initialization from './components/Initialization';
import { getUserIdInLocalDb, getUserEmailInLocalDb } from './components/redux/features/profileSlice';
import { useDispatch, useSelector } from 'react-redux';
import Home from './components/Home/Home';
import Contact from './components/Space/Contact';
import Works from './components/Space/Works';
import FreeTrialEnd from './components/Home/FreeTrialEnd';
import TemplateActivity from './components/Workplace/TemplateActivity';
import Dashboard from './components/Space/Dashboard';
import FeedLatest from './components/Workplace/FeedLatest';
import TaskExpansionDetails from './components/Space/TaskExpansionDetails';
import AccountLatest from './components/Account/AccountLatest';
import ListBeta from './components/Space/ListBeta';
import { Helmet } from 'react-helmet';
import TimeLine from './components/Space/TimeLine';
import Action from './components/Space/Action';
import ContactBulk from './components/Space/ContactBulk';
import ContactBulkCompany from './components/Space/ContactBulkCompany';
Auth.configure({
  region: process.env.REACT_APP_COGNITO_REGION,
  userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
  userPoolWebClientId: process.env.REACT_APP_USERPOOL_WEBCLIENT_ID,
  // Cognito Hosted UI configuration
  oauth: {
    domain: process.env.REACT_APP_AUTH_DOMAIN,
    redirectSignIn: `${window.location.origin}/`,
    redirectSignOut: `${window.location.origin}/`,
    responseType: 'token',
  },
});
function App() {

  const dispatch = useDispatch()

  const isLogout = useSelector((state) => state.profileData.isLogout)
  const [isAuthenticated, setAuthenticated] = React.useState(false)

  const handleLogout = async (props) => {

    await Auth.signOut({ global: true }).then(result => {

      sessionStorage.clear();
      localStorage.clear();
      document.cookie = "";
      window.location.href = '/'

    }).catch(error => {
      console.log("logout error", error)
    });

  }



  React.useState(() => {

    console.log("current Domain", window.location)

    Auth.currentAuthenticatedUser({
      bypassCache: false  // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
    }).then(user => {

      dispatch(getUserIdInLocalDb({
        userId: localStorage.getItem("userId") || ""
      }))
      dispatch(getUserEmailInLocalDb({
        userId: localStorage.getItem("userEmail") || ""
      }))
      setAuthenticated(true)

    }).catch(error => {

      setAuthenticated(false)
      if (!isLogout) {
        sessionStorage.clear();
        localStorage.clear();
        document.cookie = "";
      }

    })

  })


  React.useEffect(() => {

    // alert(isLogout)

    if (isLogout === true) {

      handleLogout(isLogout)


    }

    console.log("local storage", localStorage.getItem("userEmail"))


  }, [isLogout])



  return (
    <ThemeProvider
      theme={theme}
    >

      <Helmet>
        <link rel="icon" href="https://www.app.deski.co/deski-favIcon.png" />
      </Helmet>

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<SignIn />} />
          <Route path='/initialization' element={<Initialization />} />
          <Route path="/signup" element={<SignUp />} />
          <Route path="/forgetpassword" element={<ForgetPassword />} />
          <Route path="/resetPassword" element={<ResetPassword />} />
          <Route path="/emailVerification" element={<EmailVerification />} />
          <Route path="/workplace" element={<Home />} />
          <Route path="/createWorkplace" element={<CreateWorkplace />} />
          <Route path='/feed' element={<FeedLatest />} />
          <Route path='/taskexpansionDetails' element={<TaskExpansionDetails />} />
          <Route path='/template' element={<Template />} />
          <Route path='/portal' element={<Template />} />
          {/* Login portal for tax */}
          <Route path='/activity' element={<TemplateActivity />} />
          <Route path="/space/:name" element={<Works />} />
          <Route path="/files" element={<Files />} />
          <Route path="/list" element={<ListBeta />} />
          <Route path="/calander" element={<Calander />} />
          <Route path="/insight" element={<Insight />} />
          <Route path="/insightold" element={<Dashboard />} />
          <Route path="/team" element={<Team />} />
          <Route path="/settings" element={<Settings />} />
          <Route path="/account" element={<AccountLatest />} />
          <Route path="/accountlatest" element={<AccountLatest />} />
          <Route path='/roadmap' element={<TimeLine />} />
          <Route path='/report' element={<Insight />} />
          <Route path='/timeline' element={<TimeLine />} />
          <Route path='/action' element={<Action />} />
          <Route path="/apps" element={<Apps />} />
          <Route path="/contact" element={<Contact />} />
          <Route path='/contactbulk' element={<ContactBulk />} />
          <Route path='/clientbulk' element={<ContactBulkCompany />} />
          <Route path="/rules" element={<Rules />} />
        </Routes>


      </BrowserRouter>

    </ThemeProvider>
  );
}

export default App;
